<template>
  <div class="pb-2">
    <template v-if="checklistDetailsPending">
      <v-skeleton-loader type="text" />
    </template>
    <template v-else>
      <template v-if="hasDescription">
        <div
          class="clickable text-text-secondary"
          data-locator="task-description"
          v-html="sanitizedDescription"
          @click="onOpenChecklistPane"
        >
        </div>
      </template>
      <template v-else-if="isCurrentUserPm">
        <app-button
          class="app-button--compact"
          data-locator="add-description-button"
          size="x-small"
          type="ghost"
          variant="neutral"
          @click="onOpenChecklistPane"
        >
          {{ $t('project.checklist.table.ChecklistTableTaskDescription.descriptionPlaceholder') }}
        </app-button>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { sanitizeHtml } from '@/common/helpers/htmlHelpers'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'

export default {
  name: 'ChecklistTableTaskDescription',
  props: {
    item: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
    ...mapState('checklist', ['checklistDetailsPending']),
    hasDescription () {
      return !!this.item.description
    },
    sanitizedDescription () {
      return sanitizeHtml(this.item.description)
    },
  },
  methods: {
    ...mapActions('checklist', [OPEN_CHECKLIST_PANE]),
    onOpenChecklistPane() {
      this.OPEN_CHECKLIST_PANE({
        isOpen: true,
        parent: this.parent,
        tab: 'details',
        tasks: [this.item],
      })
    },
  },
}
</script>

